import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InitialiserDependency } from '@evorait/pace-authentication';

@Injectable({ providedIn: 'root' })
export class ServiceWorkerReadyService extends InitialiserDependency {
    public ready$ = (): Observable<unknown> => {
        if (!navigator.serviceWorker) {
            return of(undefined);
        }

        if (navigator.serviceWorker.controller) {
            // SW is already controlling the page
            return of(undefined);
        }

        return new Observable<void>((observer) => {
            const onControllerChange = (): void => {
                if (navigator.serviceWorker.controller) {
                    navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
                    observer.next();
                    observer.complete();
                }
            };
            navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
        });
    };
}
